import React from "react";

const FeedbackBanner = ({setShowFeedbackAlert, setIsFeedbackModalVisible}) => {
  return (
    <div className="bg-blue-brand-700">
      <div className="max-w-screen-xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between flex-wrap">

          <div className="flex-1 flex items-center mb-4 md:mb-0">

            <span className="flex p-2 rounded-lg bg-indigo-800">
              <svg
                className="h-6 w-6 text-white"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                />
              </svg>
            </span>

            <p className="ml-3 font-medium text-white">
              <span className="">
                We want to hear from YOU! Check out our New Feedback Form + Submit Yours Today!
              </span>
            </p>

          </div>

          <div className="items-center">
            <button 
              className="bg-red-brand-600 hover:bg-red-brand-700 text-white font-bold py-2 px-4 rounded mx-2"
              onClick={() => setShowFeedbackAlert(false)}
            > Close</button>
            <button 
              className="bg-green-brand-500 hover:bg-green-brand-700 text-white font-bold py-2 px-4 rounded mx-2"
              onClick={() =>setIsFeedbackModalVisible(true)}
            > Give Feedback</button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default FeedbackBanner;
